import { createSvgIcon } from '@mui/material'

export const TimelineIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='2' y='11' width='10' height='2' rx='1' fill='currentColor' />
    <rect x='2' y='16' width='12' height='2' rx='1' fill='currentColor' />
    <rect x='2' y='6' width='12' height='2' rx='1' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14 12C14 9.79086 15.7909 8 18 8C19.0609 8 20.0783 8.42143 20.8284 9.17157C21.5786 9.92172 22 10.9391 22 12C22 14.2091 20.2091 16 18 16C15.7909 16 14 14.2091 14 12ZM17.9999 12.4H19.5999C19.8208 12.4 19.9999 12.2209 19.9999 12C19.9999 11.7791 19.8208 11.6 19.5999 11.6H18.3999V10.4C18.3999 10.1791 18.2208 10 17.9999 10C17.779 10 17.5999 10.1791 17.5999 10.4V12C17.5999 12.2209 17.779 12.4 17.9999 12.4Z'
      fill='#161C24'
    />
  </svg>,
  'TimelineIcon',
)
